import ErrorMessages from "./ErrorMessages";

export default ErrorMessages;



// WEBPACK FOOTER //
// ./src/commonComponents/ErrorMessages/index.js